export enum LogisticsVehicleStatusType {
  Available = "Available",
  Allocated = "Allocated",
  NotAvailable = "NotAvailable"
}
